import { render, staticRenderFns } from "./ConcatInfoCard.vue?vue&type=template&id=46fe0be0&scoped=true&"
import script from "./ConcatInfoCard.vue?vue&type=script&lang=js&"
export * from "./ConcatInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./ConcatInfoCard.vue?vue&type=style&index=0&id=46fe0be0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe0be0",
  null
  
)

export default component.exports